import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
// creates a beautiful scrollbar
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import {
  DateRange,
  Assignment,
  Assessment,
  PlaylistAddCheck
} from "@material-ui/icons/";
// core components
import Navbar from "components/Navbars/Navbar.js";
import Footer from "components/Footer/Footer.js";
import Sidebar from "components/Sidebar/Sidebar.js";
import styles from "assets/jss/material-dashboard-react/layouts/adminStyle.js";

import bgImage from "assets/img/sidebar-2.jpg";
import logo from "assets/img/logo2.png";

// Views
import KpiRoundList from "views/KPI/KpiRoundList.js";
import KpiManagement from "views/KPI/KpiManagement.js";
import KpiApproval from "views/KPI/KpiApproval.js";
import MyKpi from "views/KPI/MyKpi.js";

let ps;

const routes = [
  {
    name: "จัดการรอบการประเมิน",
    icon: DateRange,
    component: KpiRoundList,
    layout: "/kpi",
    path: "/round"
  },
  {
    name: "จัดการตัวชี้วัด (KPIs)",
    icon: Assignment,
    component: KpiManagement,
    layout: "/kpi",
    path: "/manage"
  },
  {
    name: "อนุมัติตัวชี้วัดรายบุคคล",
    icon: PlaylistAddCheck,
    component: KpiApproval,
    layout: "/kpi",
    path: "/approval"
  },
  {
    name: "KPI ของฉัน & ประเมินตนเอง",
    icon: Assessment,
    component: MyKpi,
    layout: "/kpi",
    path: "/my-kpi"
  }
];

const switchRoutes = (
  <Switch>
    {routes.map((prop, key) => {
      return (
        <Route
          path={prop.layout + prop.path}
          component={prop.component}
          key={key}
        />
      );
    })}
    <Redirect from="/kpi" to="/kpi/round" />
  </Switch>
);

const useStyles = makeStyles(styles);

export default function KPILayout({ ...rest }) {
  const classes = useStyles();
  const mainPanel = React.createRef();
  const [image] = React.useState(bgImage);
  const [color] = React.useState("blue");
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const getRoute = () => {
    return window.location.pathname !== "/admin/maps";
  };

  const resizeFunction = () => {
    if (window.innerWidth >= 960) {
      setMobileOpen(false);
    }
  };

  React.useEffect(() => {
    if (navigator.platform.indexOf("Win") > -1) {
      ps = new PerfectScrollbar(mainPanel.current, {
        suppressScrollX: true,
        suppressScrollY: false
      });
      document.body.style.overflow = "hidden";
    }
    window.addEventListener("resize", resizeFunction);
    return function cleanup() {
      if (navigator.platform.indexOf("Win") > -1) {
        ps.destroy();
      }
      window.removeEventListener("resize", resizeFunction);
    };
  }, [mainPanel]);

  return (
    <div className={classes.wrapper}>
      <Sidebar
        routes={routes}
        logoText={"ระบบประเมิน KPI"}
        logo={logo}
        image={image}
        handleDrawerToggle={handleDrawerToggle}
        open={mobileOpen}
        color={color}
        {...rest}
      />
      <div className={classes.mainPanel} ref={mainPanel}>
        <Navbar
          routes={routes}
          handleDrawerToggle={handleDrawerToggle}
          {...rest}
        />
        {getRoute() ? (
          <div className={classes.content}>
            <div className={classes.container}>{switchRoutes}</div>
          </div>
        ) : (
          <div className={classes.map}>{switchRoutes}</div>
        )}
        {getRoute() ? <Footer /> : null}
      </div>
    </div>
  );
}
